export default __webpack_public_path__ + "static/media/commentPic.36909551.svg";